import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
/** 
 * @description integrates the vue router routes and 
 * defines the router guard
 * @exports VueRouter
 */

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

/**
 * This will have a more concise implentation down the road, once we
 * start using vuex.
 * https://router.vuejs.org/guide/advanced/navigation-guards.html
 */
router.beforeEach((to, from, next) => {
  next()
})

export default router